
import Swal from "sweetalert2";
import { getToken } from "./token";
import Swalaleart from "./swalaleart";
import domain from "../../reusecomponent/domain";
import { saveMedia } from "../small_component/whatsappchat/mediaCache";
import { useEffect, useState } from "react";
import { FaFileAlt } from "react-icons/fa";

export const NewTapOpen = (url) => {
  window.open(url)
}

export const ConnectWhatsapp = async (setloder) => {
  if (window.location.protocol !== 'https:') {
    ErrorToastContainer("Protocol Not Secure Contact Admin");
    return;
  }
  setloder(true);
  const myHeaders = new Headers();
  const access_token = getToken();
  myHeaders.append(`Authorization`, `Bearer ${access_token}`);
  let appconfigration = [];
  try {
    const requestOptions = {
      headers: myHeaders,
      redirect: "follow"
    };
    const res = await fetch(`${domain()}/connect_whatsapp`, requestOptions)
    if (!res.ok) {
      setloder(false);
      Swalaleart({ title: "Error1", text: "Internal Server Problem", icon: "error", });
    }
    const response = await res.json();
    if (response) {
      if (response.status) {
        appconfigration = JSON.parse(atob(response.data));
      } else {
        setloder(false);
        Swalaleart({ title: "Failed", text: response.message, icon: "warning", });
        return;
      }
    }
  } catch (error) {
    setloder(false);
    Swal.fire({
      title: "Oops!",
      text: "Something went wrong. Please try again.",
      icon: "error",
    });
    return;
  }


  let phoneNumberId = null;
  let wabaId = null;

  const loadFacebookSDK = () => {
    if (window.FB) {
      setloder(false);
      ErrorToastContainer("Facebook SDK already loaded.");
      return;
    }

    const script = document.createElement("script");
    script.src = "https://connect.facebook.net/en_US/sdk.js";
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.onload = () => {
      initFacebookSDK();
    };
    document.body.appendChild(script);
  };

  const initFacebookSDK = () => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: atob(appconfigration[0]),
        autoLogAppEvents: true,
        xfbml: true,
        version: "v22.0",
      });
      // ErrorToastContainer("Facebook SDK initialized");
      if (window.FB) {
        // ErrorToastContainer("FB SDK Ready!");
      } else {
        ErrorToastContainer("FB is not available after initialization.");
      }
    };
  };

  const launchWhatsAppSignup = () => {

    if (!window.FB) {
      setTimeout(launchWhatsAppSignup, 1000);
      return;
    }

    // Listen for WhatsApp Embedded Signup Event
    window.addEventListener("message", (event) => {
      if (event.origin !== "https://www.facebook.com" && event.origin !== "https://web.facebook.com") return;

      try {
        const data = JSON.parse(event.data);
        if (data.type === "WA_EMBEDDED_SIGNUP") {
          phoneNumberId = data.data.phone_number_id;
          wabaId = data.data.waba_id;
        }
      } catch (error) {
        setloder(false);
      }
    });
    window.FB.login(
      (response) => {
        if (response.authResponse) {
          Swal.fire({
            title: "Succes",
            text: "Please Wait Some Time",
            icon: "success",
            showConfirmButton: false,
            timer: 1000
          }).then(async () => {
            setloder(true);
            try {
              const formdata = new FormData();
              const data = { "access_token": response.authResponse.code, "waba_id": wabaId, "phone_number_id": phoneNumberId };
              formdata.append("data", btoa(JSON.stringify(data)));
              const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: formdata,
                redirect: "follow"
              };
              const res = await fetch(`${domain()}/connect_whatsapp`, requestOptions)
              if (!res.ok) {
                setloder(false);
                Swalaleart({ title: "Error1", text: "Internal Server Problem", icon: "error", });
              }

              const insert_response = await res.json();
              if (insert_response) {
                setloder(false);
                if (insert_response.status) {
                  Swalaleart({ title: "Success", text: insert_response.message, icon: "success", confirmcolor: '#1fee5b' });
                  // The UserPermissionContext will automatically update after successful connection
                  // No need for manual callback since the context handles the state
                } else {
                  Swalaleart({ title: "Failed", text: insert_response.message, icon: "warning", });
                }
              }
            } catch (error) {
              setloder(false);
              Swalaleart({ title: "Error2", text: "Network Error", icon: "error", });
            }

          })
        } else {
          setloder(false);
          ErrorToastContainer("User cancelled login or did not fully authorize.");
        }
      },
      {
        config_id: atob(appconfigration[1]),
        response_type: "code",
        override_default_response_type: true,
        auth_type: "rerequest",
        extras: {
          version: "v3",
          sessionInfoVersion: "3",
          ...(appconfigration[2] && {
            setup: {
              solutionID: atob(appconfigration[2]),
            },
          }),
        },
      }
    );
  };

  loadFacebookSDK();

  setTimeout(() => {
    launchWhatsAppSignup();
  }, 2000);
};


export const ErrorToastContainer = (message = 'Some Technical issue') => {
  try {
    Swal.fire({

      icon: 'error',
      title: 'Error',
      text: message,
      timer: 4000,
      showConfirmButton: false,
      toast: true,
      position: 'top-end',
      timerProgressBar: true,
      background: '#fff',
      color: '#333',
      zIndex: 10000,
      customClass: {
        popup: 'swal2-toast-custom',
        title: 'swal2-toast-title',
        content: 'swal2-toast-content',
        icon: 'swal2-toast-icon'
      },
      showClass: {
        popup: 'animate__animated animate__fadeInRight'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutRight'
      },
      width: '400px',
      padding: '1rem',
      backdrop: false,
      allowOutsideClick: true,
      allowEscapeKey: true,
      stopKeydownPropagation: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    });
  } catch (error) {
    alert(message);
  }
}

export const SuccessToastContainer = (message = 'Success') => {
  try {
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: message,
      timer: 4000,
      showConfirmButton: false,
      toast: true,
      position: 'top-end',
      timerProgressBar: true,
      background: '#fff',
      color: '#333',
      zIndex: 10000,
      customClass: {
        popup: 'swal2-toast-custom',
        title: 'swal2-toast-title',
        content: 'swal2-toast-content',
        icon: 'swal2-toast-icon'
      },
      showClass: {
        popup: 'animate__animated animate__fadeInRight'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutRight'
      },
      width: '400px',
      padding: '1rem',
      backdrop: false,
      allowOutsideClick: true,
      allowEscapeKey: true,
      stopKeydownPropagation: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    });
  } catch (error) {
    console.error('Alert error:', error);
    alert(message);
  }
}

export const WorningToastContainer = (message = 'Some Technical issue') => {
  try {
    Swal.fire({
      icon: 'warning',
      title: 'Warning',
      text: message,
      timer: 4000,
      showConfirmButton: false,
      toast: true,
      position: 'top-end',
      timerProgressBar: true,
      background: '#fff',
      color: '#333',
      zIndex: 10000,
      customClass: {
        popup: 'swal2-toast-custom',
        title: 'swal2-toast-title',
        content: 'swal2-toast-content',
        icon: 'swal2-toast-icon'
      },
      showClass: {
        popup: 'animate__animated animate__fadeInRight'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutRight'
      },
      width: '400px',
      padding: '1rem',
      backdrop: false,
      allowOutsideClick: true,
      allowEscapeKey: true,
      stopKeydownPropagation: false,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
      }
    });
  } catch (error) {
    console.error('Alert error:', error);
    alert(message);
  }
}

const AVATAR_PALETTE = [
  "#275C53", // Deep Teal
  "#E91E63", // Pink
  "#FF5722", // Deep Orange
  "#FF9800", // Orange
  "#4CAF50", // Green
  "#009688", // Teal
  "#00BCD4", // Cyan
  "#03A9F4", // Light Blue
  "#2196F3", // Blue
  "#3F51B5", // Indigo
  "#673AB7", // Deep Purple
  "#9C27B0", // Purple
  "#F44336", // Red
  "#00897B", // Persian Green
  "#D81B60", // Rose
  "#8E24AA", // Violet
  "#5E35B1", // Royal Purple
  "#3949AB", // Dark Blue
  "#1E88E5", // Bright Blue
  "#039BE5", // Cerulean
  "#00ACC1", // Dark Cyan
  "#43A047", // Emerald
  "#FB8C00", // Amber Orange
  "#F4511E", // Flame
];

export const getInitials = (customer) => {
  if (!customer) return "C";

  if (typeof customer === "string") {
    const trimmed = customer.trim();
    if (!trimmed) return "C";
    const alphaMatch = trimmed.match(/[a-zA-Z0-9]/);
    if (alphaMatch) {
      return alphaMatch[0].toUpperCase();
    }
    try {
      const chars = Array.from(trimmed);
      if (chars.length > 0 && chars[0].trim()) {
        return chars[0];
      }
    } catch (_) { }
    return "C";
  }

  const rawName = (
    customer.contact_name ||
    customer.name ||
    customer.wa_id ||
    customer.number ||
    customer.mobile ||
    ""
  ).toString().trim();

  if (!rawName) return "C";

  // If there is an alphanumeric character, use the first letter/digit
  const alphaMatch = rawName.match(/[a-zA-Z0-9]/);
  if (alphaMatch) {
    return alphaMatch[0].toUpperCase();
  }

  // Otherwise safely extract the first unicode character/emoji using Array.from to avoid surrogate fragmentation
  try {
    const chars = Array.from(rawName);
    if (chars.length > 0 && chars[0].trim()) {
      return chars[0];
    }
  } catch (_) { }

  return "C";
};

export const getAvatarColor = (customer) => {
  if (!customer) return AVATAR_PALETTE[0];

  const seed = typeof customer === "string"
    ? customer.trim()
    : String(
      customer.wa_id ||
      customer.contact_name ||
      customer.name ||
      customer.number ||
      customer.mobile ||
      "C"
    ).trim();

  if (!seed) return AVATAR_PALETTE[0];

  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = (hash << 5) - hash + seed.charCodeAt(i);
    hash |= 0;
  }
  const index = Math.abs(hash) % AVATAR_PALETTE.length;
  return AVATAR_PALETTE[index];
};

export const getDisplayName = (customer) => {
  if (!customer) return "Unknown";
  const contactName = customer.contact_name && String(customer.contact_name).trim();
  if (contactName) {
    return contactName.length > 20 ? contactName.slice(0, 17) + "..." : contactName;
  }
  const name = customer.name && String(customer.name).trim();
  if (name) {
    return name.length > 20 ? name.slice(0, 17) + "..." : name;
  }
  if (customer.wa_id) return customer.wa_id;
  return "Unknown";
};

export const getStatusIcon = (status) => {
  switch (status) {
    case "0":
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="ms-1"
        >
          <circle
            cx="8"
            cy="8"
            r="7"
            stroke="#8E8E93"
            strokeWidth="1.5"
            fill="none"
          />
          <path
            d="M8 4V8L10.5 10.5"
            stroke="#8E8E93"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      );
    case "1": // sent
      return (
        <svg
          width="16"
          height="11"
          viewBox="0 0 16 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="ms-1"
        >
          <path
            d="M1.5 5.5L5.5 9.5L14.5 1.5"
            stroke="#8E8E93"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "2": // delivered (two gray ticks)
      return (
        <svg
          width="16"
          height="11"
          viewBox="0 0 16 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="ms-1"
        >
          <path
            d="M1 5.5L5 9.5L10 1.5"
            stroke="#8E8E93"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 5.5L10 9.5L15 1.5"
            stroke="#8E8E93"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "3": // read (two blue, bold ticks)
      return (
        <svg
          width="16"
          height="11"
          viewBox="0 0 16 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="ms-1"
        >
          <path
            d="M1 5.5L5 9.5L10 1.5"
            stroke="#34B7F1"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6 5.5L10 9.5L15 1.5"
            stroke="#34B7F1"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "4": // failed
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="ms-1"
        >
          <circle
            cx="7"
            cy="7"
            r="6"
            stroke="#e53935"
            strokeWidth="2"
            fill="none"
          />
          <path
            d="M7 4V8"
            stroke="#e53935"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle cx="7" cy="10" r="1" fill="#e53935" />
        </svg>
      );
    case "5": // deleted
      return (
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="ms-1"
          style={{ opacity: 0.5 }}
        >
          <rect x="3" y="6" width="8" height="2" rx="1" fill="#888" />
        </svg>
      );
    default:
      return null;
  }
};


export function formatMessageTime(messagedate, messagetime) {
  const fullDateTime = `${messagedate} ${messagetime}`;

  // Convert string → valid JS Date
  const msgDate = new Date(fullDateTime.replace(" ", "T"));

  const now = new Date();
  const differenceInDays = Math.floor((now - msgDate) / (1000 * 60 * 60 * 24));

  // Today → show hh:mm AM/PM
  if (differenceInDays === 0) {
    return msgDate.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  }

  // Yesterday
  if (differenceInDays === 1) {
    return "Yesterday";
  }

  return msgDate.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
  });
}

export const getAgentLabel = (agent_id) => {
  if (agent_id === null || agent_id === undefined || agent_id === "" || agent_id === "null") {
    return "Owner";
  }
  const idStr = String(agent_id).trim();
  switch (idStr) {
    case "001":
      return "Chatbot";
    case "002":
      return "Auto Responder";
    case "003":
      return "Broadcast Test";
    case "004":
      return "Broadcast";
    case "005":
      return "API";
    default:
      return "Agent";
  }
};

export const SendDocument = (wadetails, setCustomerschat, setDocumentUploader) => {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = "*/*";
  input.style.display = "none";
  document.body.appendChild(input);

  input.onchange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      document.body.removeChild(input);
      return;
    }
    // Open the modal by passing the file object
    setDocumentUploader({ file, wadetails });
    document.body.removeChild(input);
  };

  input.click();
};

export function DocumentUploadModal({ uploadData, setCustomerschat, onClose }) {
  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("Initializing...");

  const { file, wadetails } = uploadData;
  const token = getToken();
  const userinfo = decodeJWT(token);

  useEffect(() => {
    const processUpload = async () => {
      try {
        const clientSystemId = generateOrderId();
        const chunkSize = 1024 * 1024 * 2; // 2MB Chunks
        const totalChunks = Math.ceil(file.size / chunkSize);
        const fileName = `${clientSystemId}_${file.name}`;
        let finalFileId = null;

        // --- CHUNKED UPLOAD LOGIC ---
        for (let i = 0; i < totalChunks; i++) {
          const start = i * chunkSize;
          const end = Math.min(start + chunkSize, file.size);
          const blob = file.slice(start, end);

          const formData = new FormData();
          formData.append("user_id", userinfo.id);
          formData.append("agent_id", userinfo.agent_id);
          formData.append("number", wadetails.wa_id);
          formData.append("body_type", "document");
          formData.append("chunkIndex", i);
          formData.append("totalChunks", totalChunks);
          formData.append("fileName", fileName);
          formData.append("file", blob, file.name);

          setStatus(`Uploading chunk ${i + 1} of ${totalChunks}...`);

          const res = await fetch(`${domain()}/sendmessage/uploade_file`, {
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            body: formData,
          });

          if (!res.ok) throw new Error("Server rejected file chunk. Check file size limits.");

          const data = await res.json();
          if (data.file_id) finalFileId = data.file_id;

          // Update progress (0 to 90% for upload)
          setProgress(Math.round(((i + 1) / totalChunks) * 90));
        }

        if (!finalFileId) throw new Error("Upload completed but no File ID returned.");

        // --- SUCCESS: CACHE AND SEND MESSAGE ---
        setStatus("Finalizing message...");
        saveMedia("document", "outgoing", finalFileId.split(".").shift(), file);

        const msgFormData = new FormData();
        msgFormData.append("user_id", userinfo.id);
        msgFormData.append("agent_id", userinfo.agent_id);
        msgFormData.append("number", wadetails.wa_id);
        msgFormData.append("client_system_id", clientSystemId);
        msgFormData.append("body_type", "document");
        msgFormData.append("file_title", file.name);
        msgFormData.append("message_deliver", 0);
        msgFormData.append("type", "outgoing");
        msgFormData.append("file", finalFileId);

        const now = new Date();
        const chatObj = {
          user_id: userinfo.id,
          agent_id: userinfo.agent_id,
          number: wadetails.wa_id,
          body: null,
          body_type: "document",
          file_title: file.name,
          client_system_id: clientSystemId,
          file_id: finalFileId.split(".").shift(),
          message_deliver: 0,
          type: "outgoing",
          date: now.toISOString().split("T")[0],
          time: now.toTimeString().split(" ")[0],
        };

        // Update UI
        setCustomerschat((prev) => ({
          ...prev,
          data: [chatObj, ...prev.data],
        }));

        await fetch(`${domain()}/sendmessage`, {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: msgFormData,
        });

        setProgress(100);
        setStatus("Success!");

        // Auto close after brief success message
        setTimeout(onClose, 1000);

      } catch (error) {
        console.error(error);
        alert(`Upload Failed: ${error.message}`);
        onClose(); // Close modal on failure as requested
      }
    };

    processUpload();
  }, []);

  return (
    <div style={docOverlayStyle}>
      <div style={docModalStyle}>
        <h5 style={{ marginBottom: "15px" }}>Uploading Document</h5>
        <div style={{ fontSize: "0.9rem", color: "#555", marginBottom: "10px" }}>{file.name}</div>
        <div style={progressContainerStyle}>
          <div style={{ ...progressBarStyle, width: `${progress}%` }}></div>
        </div>
        <div style={{ marginTop: "10px", fontSize: "0.8rem", textAlign: "center" }}>
          {status} ({progress}%)
        </div>
      </div>
    </div>
  );
}

// Styles for the Document Modal
const docOverlayStyle = {
  position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
  background: "rgba(0,0,0,0.7)", display: "flex", justifyContent: "center",
  alignItems: "center", zIndex: 10001,
};
const docModalStyle = {
  width: "350px", background: "#fff", padding: "25px", borderRadius: "12px",
  boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
};
const progressContainerStyle = {
  width: "100%", height: "12px", background: "#eee", borderRadius: "6px", overflow: "hidden",
};
const progressBarStyle = {
  height: "100%", background: "#25D366", transition: "width 0.3s ease",
};

// export const SendVideo = (wadetails, setCustomerschat) => {
//   const input = document.createElement("input");
//   input.type = "file";
//   input.accept = "video/*";
//   input.style.display = "none";
//   document.body.appendChild(input);

//   input.onchange = async (e) => {
//     const token = getToken();
//     const userinformation = decodeJWT(token);
//     const file = e.target.files[0];

//     if (!file || !file.type.startsWith("video/")) {
//       document.body.removeChild(input);
//       return;
//     }

//     /* ---------------------------------
//        1️⃣ upload video first (chunk ready)
//     --------------------------------- */
//     const fileId = await uploadFileToServer(file, token, {
//       user_id: userinformation.id,
//       agent_id: userinformation.agent_id,
//       number: wadetails.wa_id,
//       body_type: "video",
//     });

//     if (fileId === false) {
//       ErrorToastContainer("Video upload failed");
//       document.body.removeChild(input);
//       return;
//     }

//     const genarateid = generateOrderId();
//     // Save locally using server file id
//     saveMedia(
//       "video",
//       "outgoing",
//       fileId.split(".").shift(),
//       file
//     );

//     /* ---------------------------------
//        2️⃣ send message with returned id
//     --------------------------------- */
//     const formData = new FormData();
//     formData.append("user_id", userinformation.id);
//     formData.append("agent_id", userinformation.agent_id);
//     formData.append("number", wadetails.wa_id);
//     formData.append("body_type", "video");
//     formData.append("file_title", "video");
//     formData.append("message_deliver", 0);
//     formData.append("type", "outgoing");
//     formData.append("client_system_id", genarateid);

//     // 🔥 send only ID
//     formData.append("file", fileId);

//     const now = new Date();

//     const chatobj = {
//       user_id: userinformation.id,
//       agent_id: userinformation.agent_id,
//       number: wadetails.wa_id,
//       body: null,
//       body_type: "video",
//       file_title: "video",
//       file_id: fileId.split(".").shift(),
//       message_deliver: 0,
//       type: "outgoing",
//       client_system_id: genarateid,
//       date: now.toISOString().split("T")[0],
//       time: now.toTimeString().split(" ")[0],
//     };

//     // instant UI update
//     setCustomerschat((prev) => ({
//       ...prev,
//       data: [chatobj, ...prev.data],
//     }));

//     await fetch(`${domain()}/sendmessage`, {
//       method: "POST",
//       headers: { Authorization: `Bearer ${token}` },
//       body: formData,
//     });

//     document.body.removeChild(input);
//   };

//   input.click();
// };

export const SendVideo = (
  wadetails,
  setCustomerschat,
  setVideoUploader
) => {

  const input = document.createElement("input");

  input.type = "file";

  input.accept = "video/*";

  input.style.display = "none";

  document.body.appendChild(input);

  input.onchange = (e) => {

    const file = e.target.files[0];

    // ❌ No file selected
    if (!file) {

      document.body.removeChild(input);

      return;
    }

    // ❌ Invalid file type
    if (!file.type.startsWith("video/")) {

      ErrorToastContainer(
        "Please select a valid video file"
      );

      document.body.removeChild(input);

      return;
    }

    // ✅ WhatsApp max video size = 16MB
    const MAX_VIDEO_SIZE = 16 * 1024 * 1024;

    if (file.size > MAX_VIDEO_SIZE) {

      const fileSizeMB = (
        file.size /
        (1024 * 1024)
      ).toFixed(2);

      ErrorToastContainer(
        `Selected video is ${fileSizeMB}MB. Maximum allowed size is 16MB`
      );

      document.body.removeChild(input);

      return;
    }

    // ✅ Open Upload Modal
    setVideoUploader({
      file,
      wadetails,
    });

    document.body.removeChild(input);
  };

  input.click();
};

export const SendImage = (wadetails, setCustomerschat, setUploaderOpen) => {
  const input = document.createElement("input");

  input.type = "file";
  input.accept = ".jpg,.jpeg,.png,.webp";
  input.multiple = true; // ✅ multiple enabled
  input.style.display = "none";

  document.body.appendChild(input);

  input.onchange = (e) => {
    const files = Array.from(e.target.files);

    if (!files.length) return;

    // open modal + pass files
    setUploaderOpen(files);
    document.body.removeChild(input);
  };

  input.click();
};

export const RecordAudio = (wadetails, setCustomerschat) => {

  const modal = document.createElement("div");

  modal.style.position = "fixed";
  modal.style.top = "0";
  modal.style.left = "0";
  modal.style.width = "100%";
  modal.style.height = "100%";
  modal.style.background = "rgba(0,0,0,0.5)";
  modal.style.display = "flex";
  modal.style.justifyContent = "center";
  modal.style.alignItems = "center";
  modal.style.zIndex = "999999";

  modal.innerHTML = `
    <div style="
      width:350px;
      background:white;
      border-radius:10px;
      padding:20px;
      text-align:center;
    ">

      <h4>Voice Recorder</h4>

      <div id="recording-time"
        style="
          font-size:32px;
          margin:20px 0;
          color:red;
        "
      >
        00:00
      </div>

      <audio
        id="audio-preview"
        controls
        style="
          width:100%;
          display:none;
          margin-bottom:15px;
        "
      ></audio>

      <div
        style="
          display:flex;
          gap:10px;
          flex-wrap:wrap;
          justify-content:center;
        "
      >

        <button id="start-record"
          class="btn btn-success">
          Start
        </button>

        <button id="stop-record"
          class="btn btn-danger">
          Stop
        </button>

        <button id="reset-record"
          class="btn btn-warning">
          Reset
        </button>

        <button id="send-record"
          class="btn btn-primary">
          Send
        </button>

        <button id="close-record"
          class="btn btn-secondary">
          Close
        </button>

      </div>
    </div>
  `;

  document.body.appendChild(modal);

  const startBtn =
    modal.querySelector("#start-record");

  const stopBtn =
    modal.querySelector("#stop-record");

  const resetBtn =
    modal.querySelector("#reset-record");

  const sendBtn =
    modal.querySelector("#send-record");

  const closeBtn =
    modal.querySelector("#close-record");

  const preview =
    modal.querySelector("#audio-preview");

  const timerElement =
    modal.querySelector("#recording-time");

  let mediaRecorder;

  let audioChunks = [];

  let audioBlob = null;

  let audioFile = null;

  let timer;

  let seconds = 0;

  const updateTimer = () => {

    seconds++;

    const mins = String(
      Math.floor(seconds / 60)
    ).padStart(2, "0");

    const secs = String(
      seconds % 60
    ).padStart(2, "0");

    timerElement.innerText =
      `${mins}:${secs}`;
  };

  /* ===================================
      START RECORD
  ==================================== */

  startBtn.onclick = async () => {

    try {

      const stream =
        await navigator.mediaDevices.getUserMedia({
          audio: true,
        });

      // ✅ WhatsApp Supported Codec
      mediaRecorder =
        new MediaRecorder(stream, {
          mimeType: "audio/webm;codecs=opus",
        });

      audioChunks = [];

      seconds = 0;

      timerElement.innerText = "00:00";

      timer = setInterval(updateTimer, 1000);

      mediaRecorder.ondataavailable = (e) => {

        if (e.data.size > 0) {
          audioChunks.push(e.data);
        }
      };

      mediaRecorder.onstop = async () => {

        clearInterval(timer);

        // original webm audio
        const webmBlob = new Blob(audioChunks, {
          type: "audio/webm",
        });

        try {

          SuccessToastContainer(
            "Converting to MP3..."
          );

          // =========================
          // LOAD FFMPEG
          // =========================

          const { FFmpeg } = await import("@ffmpeg/ffmpeg");

          const { fetchFile } = await import("@ffmpeg/util");

          const ffmpeg = new FFmpeg();

          await ffmpeg.load();

          // =========================
          // WRITE INPUT
          // =========================

          await ffmpeg.writeFile(
            "input.webm",
            await fetchFile(webmBlob)
          );

          // =========================
          // CONVERT TO MP3
          // =========================

          await ffmpeg.exec([
            "-i",
            "input.webm",
            "-vn",
            "-ar",
            "44100",
            "-ac",
            "2",
            "-b:a",
            "192k",
            "output.mp3",
          ]);

          // =========================
          // READ OUTPUT
          // =========================

          const data =
            await ffmpeg.readFile("output.mp3");

          audioBlob = new Blob(
            [data.buffer],
            {
              type: "audio/mpeg",
            }
          );

          audioFile = new File(
            [audioBlob],
            `audio_${Date.now()}.mp3`,
            {
              type: "audio/mpeg",
            }
          );

          preview.src =
            URL.createObjectURL(audioBlob);

          preview.style.display = "block";

          SuccessToastContainer(
            "MP3 Ready"
          );

        } catch (err) {

          console.error(err);

          ErrorToastContainer(
            "MP3 conversion failed"
          );
        }
      };

      mediaRecorder.start();

      SuccessToastContainer(
        "Recording Started"
      );

    } catch (err) {

      console.error(err);

      ErrorToastContainer(
        "Microphone permission denied"
      );
    }
  };

  /* ===================================
      STOP RECORD
  ==================================== */

  stopBtn.onclick = () => {

    if (mediaRecorder) {

      mediaRecorder.stop();

      mediaRecorder.stream
        .getTracks()
        .forEach((track) => track.stop());

      SuccessToastContainer(
        "Recording Stopped"
      );
    }
  };

  /* ===================================
      RESET
  ==================================== */

  resetBtn.onclick = () => {

    audioChunks = [];

    audioBlob = null;

    audioFile = null;

    preview.src = "";

    preview.style.display = "none";

    seconds = 0;

    timerElement.innerText = "00:00";

    clearInterval(timer);

    SuccessToastContainer(
      "Recording Reset"
    );
  };

  /* ===================================
      CLOSE
  ==================================== */

  closeBtn.onclick = () => {

    clearInterval(timer);

    document.body.removeChild(modal);
  };

  /* ===================================
      SEND AUDIO
  ==================================== */

  sendBtn.onclick = async () => {

    try {

      if (!audioFile) {

        ErrorToastContainer(
          "Please record audio first"
        );

        return;
      }

      // ✅ WhatsApp Limit
      const MAX_AUDIO_SIZE =
        16 * 1024 * 1024;

      if (
        audioFile.size > MAX_AUDIO_SIZE
      ) {

        ErrorToastContainer(
          "Audio exceeds 16MB"
        );

        return;
      }

      const token = getToken();

      const userinfo = decodeJWT(token);

      /* ============================
          UPLOAD AUDIO
      ============================ */

      const fileId =
        await uploadFileToServer(
          audioFile,
          token,
          {
            user_id: userinfo.id,
            agent_id: userinfo.agent_id,
            number: wadetails.wa_id,
            body_type: "audio",
          }
        );

      if (!fileId) {

        ErrorToastContainer(
          "Upload failed"
        );

        return;
      }

      const genId =
        generateOrderId();

      saveMedia(
        "audio",
        "outgoing",
        fileId.split(".").shift(),
        audioFile
      );

      /* ============================
          SEND MESSAGE
      ============================ */

      const formData =
        new FormData();

      formData.append(
        "user_id",
        userinfo.id
      );

      formData.append(
        "agent_id",
        userinfo.agent_id
      );

      formData.append(
        "number",
        wadetails.wa_id
      );

      formData.append(
        "body_type",
        "audio"
      );

      formData.append(
        "file_title",
        "audio"
      );

      formData.append(
        "message_deliver",
        0
      );

      formData.append(
        "type",
        "outgoing"
      );

      formData.append(
        "client_system_id",
        genId
      );

      formData.append(
        "file",
        fileId
      );

      const now = new Date();

      const chatObj = {
        user_id: userinfo.id,
        agent_id: userinfo.agent_id,
        number: wadetails.wa_id,
        body: null,
        body_type: "audio",
        file_title: "audio",
        file_id:
          fileId.split(".").shift(),
        message_deliver: 0,
        type: "outgoing",
        client_system_id: genId,
        date: now
          .toISOString()
          .split("T")[0],
        time: now
          .toTimeString()
          .split(" ")[0],
      };

      // ✅ instant UI update
      setCustomerschat((prev) => ({
        ...prev,
        data: [chatObj, ...prev.data],
      }));

      await fetch(
        `${domain()}/sendmessage`,
        {
          method: "POST",
          headers: {
            Authorization:
              `Bearer ${token}`,
          },
          body: formData,
        }
      );

      SuccessToastContainer(
        "Audio Sent"
      );

      document.body.removeChild(modal);

    } catch (err) {

      console.error(err);

      ErrorToastContainer(
        "Audio send failed"
      );
    }
  };
};

export const SendAudio = async (
  wadetails,
  setCustomerschat
) => {

  try {

    const stream = await navigator.mediaDevices.getUserMedia({
      audio: true,
    });

    const mediaRecorder = new MediaRecorder(stream);

    const audioChunks = [];

    let isStopped = false;

    mediaRecorder.ondataavailable = (event) => {

      if (event.data.size > 0) {
        audioChunks.push(event.data);
      }
    };

    mediaRecorder.onstop = async () => {

      if (isStopped) return;

      isStopped = true;

      const audioBlob = new Blob(audioChunks, {
        type: "audio/webm",
      });

      const file = new File(
        [audioBlob],
        `audio_${Date.now()}.webm`,
        {
          type: "audio/webm",
        }
      );

      // WhatsApp limit 16MB
      const MAX_AUDIO_SIZE = 16 * 1024 * 1024;

      if (file.size > MAX_AUDIO_SIZE) {

        ErrorToastContainer(
          "Audio exceeds 16MB limit"
        );

        return;
      }

      const token = getToken();

      const userinfo = decodeJWT(token);

      /* -------------------------------
         Upload audio
      -------------------------------- */

      const fileId = await uploadFileToServer(
        file,
        token,
        {
          user_id: userinfo.id,
          agent_id: userinfo.agent_id,
          number: wadetails.wa_id,
          body_type: "audio",
        }
      );

      if (!fileId) {

        ErrorToastContainer(
          "Audio upload failed"
        );

        return;
      }

      const genId = generateOrderId();

      saveMedia(
        "audio",
        "outgoing",
        fileId.split(".").shift(),
        file
      );

      /* -------------------------------
         Send message
      -------------------------------- */

      const formData = new FormData();

      formData.append("user_id", userinfo.id);

      formData.append("agent_id", userinfo.agent_id);

      formData.append("number", wadetails.wa_id);

      formData.append("body_type", "audio");

      formData.append("file_title", "audio");

      formData.append("message_deliver", 0);

      formData.append("type", "outgoing");

      formData.append(
        "client_system_id",
        genId
      );

      formData.append("file", fileId);

      const now = new Date();

      const chatObj = {
        user_id: userinfo.id,
        agent_id: userinfo.agent_id,
        number: wadetails.wa_id,
        body: null,
        body_type: "audio",
        file_title: "audio",
        file_id: fileId.split(".").shift(),
        message_deliver: 0,
        type: "outgoing",
        client_system_id: genId,
        date: now.toISOString().split("T")[0],
        time: now.toTimeString().split(" ")[0],
      };

      // instant UI update
      setCustomerschat((prev) => ({
        ...prev,
        data: [chatObj, ...prev.data],
      }));

      await fetch(`${domain()}/sendmessage`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: formData,
      });

      ErrorToastContainer(
        "Audio sent successfully"
      );
    };

    // start recording
    mediaRecorder.start();

    ErrorToastContainer(
      "Recording started... Click OK after 10 seconds"
    );

    // auto stop after 10 sec
    setTimeout(() => {

      mediaRecorder.stop();

      stream.getTracks().forEach((track) =>
        track.stop()
      );

    }, 10000);

  } catch (err) {

    console.error(err);

    ErrorToastContainer(
      "Microphone permission denied"
    );
  }
};

export const SendTextMessage = async (wadetails, text, customerschat, setCustomerschat) => {
  const token = getToken();
  const userinformation = decodeJWT(token);
  const genarateid = generateOrderId();

  const formData = new FormData();
  formData.append("user_id", userinformation.id);
  formData.append("agent_id", userinformation.agent_id);
  formData.append("client_system_id", genarateid);
  formData.append("number", wadetails.wa_id);
  formData.append("body_type", "text");
  formData.append("body", text);
  formData.append("message_deliver", 0);
  formData.append("type", "outgoing");

  const now = new Date();

  const chatobj = {
    "user_id": userinformation.id,
    "agent_id": userinformation.agent_id,
    "number": wadetails.wa_id,
    "body": text,
    "body_type": "text",
    "message_deliver": 0,
    "type": 'outgoing',
    "client_system_id": genarateid,
    "date": now.toISOString().split("T")[0],
    "time": now.toTimeString().split(" ")[0]
  };

  if (typeof setCustomerschat === "function") {
    setCustomerschat(prev => ({
      ...prev,
      data: [chatobj, ...(prev?.data ?? [])]
    }));
  } else if (customerschat?.data) {
    customerschat.data.unshift(chatobj);
  }

  // Send request
  let res = await fetch(`${domain()}/sendmessage`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: formData, // FormData must not have Content-Type manually
  });
};

function decodeJWT(token) {
  const base64Url = token.split(".")[1];                  // get payload part
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("")
  );

  return JSON.parse(jsonPayload);
}

export const fetchTemplateDetails = async (templateId) => {
  const token = getToken();
  if (!token) {
    console.error('No authentication token found');
    return null;
  }

  try {
    const response = await fetch(`${domain()}/edit/${btoa(templateId)}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    return data;
  } catch (error) {
    return null;
  }
};

async function uploadFileToServer(file, token, extraData) {
  const chunkSize = getChunkSize(file.size);

  /* -----------------------------
     SMALL FILE (normal upload)
  ----------------------------- */
  if (!chunkSize) {
    const formData = new FormData();

    Object.keys(extraData).forEach(k =>
      formData.append(k, extraData[k])
    );

    formData.append("file", file);

    const res = await fetch(`${domain()}/sendmessage/uploade_file`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData
    });

    if (!res.ok) return false;

    const data = await res.json();
    return data.file_id;
  }


  /* -----------------------------
     CHUNK UPLOAD (FIXED)
  ----------------------------- */
  const totalChunks = Math.ceil(file.size / chunkSize);
  const fileName =
    (extraData.client_system_id || Date.now()) + "_" + file.name;

  let finalFileId = null;

  for (let i = 0; i < totalChunks; i++) {

    const start = i * chunkSize;
    const end = Math.min(start + chunkSize, file.size);
    const blob = file.slice(start, end);

    const formData = new FormData();

    Object.keys(extraData).forEach(k =>
      formData.append(k, extraData[k])
    );

    formData.append("chunkIndex", i);
    formData.append("totalChunks", totalChunks);
    formData.append("fileName", fileName);
    formData.append("file", blob, file.name);

    const res = await fetch(`${domain()}/sendmessage/uploade_file`, {
      method: "POST",
      headers: { Authorization: `Bearer ${token}` },
      body: formData
    });

    if (!res.ok) {
      WorningToastContainer("File upload failed");
      return false;
    }

    const data = await res.json();

    // ✅ ONLY store id if server returns it (usually last chunk)
    if (data.file_id) {
      finalFileId = data.file_id;
    }
  }

  return finalFileId;
}

function getChunkSize(fileSize) {
  const MB = 1024 * 1024;
  const GB = 1024 * MB;

  if (fileSize < 5 * MB) return null;
  if (fileSize <= 20 * MB) return 5 * MB;
  if (fileSize <= 500 * MB) return 10 * MB;
  if (fileSize <= 2 * GB) return 17 * MB;

  return 25 * MB;
}

function generateOrderId() {
  const now = new Date();

  const dateTimeString =
    now.getFullYear().toString().padStart(4, "0") +
    (now.getMonth() + 1).toString().padStart(2, "0") +
    now.getDate().toString().padStart(2, "0") +
    now.getHours().toString().padStart(2, "0") +
    now.getMinutes().toString().padStart(2, "0") +
    now.getSeconds().toString().padStart(2, "0");

  const randomNumber = (1111 + Math.floor(Math.random() * (9999 - 1111 + 1))).toString();

  return dateTimeString + randomNumber;
}

export default function ImageUploadModal({
  files: initialFiles,
  wadetails,
  setCustomerschat,
  onClose
}) {
  const [files, setFiles] = useState(initialFiles); // ✅ local editable list
  const [uploading, setUploading] = useState(false);
  const [progress, setProgress] = useState(0);

  const token = getToken();
  const userinformation = decodeJWT(token);

  // ✅ remove image
  const removeFile = (index) => {
    setFiles(prev => prev.filter((_, i) => i !== index));
  };

  const handleSend = async () => {
    if (!files.length) return;

    setUploading(true);

    const uploaded = [];   // success list
    const failed = [];     // failed list

    /* ---------------------------------
      1️⃣ UPLOAD ALL FIRST
    --------------------------------- */
    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      try {
        const fileId = await uploadFileToServer(file, token, {
          user_id: userinformation.id,
          agent_id: userinformation.agent_id,
          number: wadetails.wa_id,
          body_type: "image",
        });

        if (!fileId) {
          failed.push(file.name);
        } else {
          uploaded.push({
            file,
            fileId,
          });
        }
      } catch {
        failed.push(file.name);
      }

      setProgress(Math.round(((i + 1) / files.length) * 50)); // 50% upload
    }

    /* ---------------------------------
      SHOW FAILED
    --------------------------------- */
    if (failed.length) {
      alert(`Failed upload:\n${failed.join("\n")}`);
    }

    /* ---------------------------------
      2️⃣ SEND MESSAGE ONE BY ONE
    --------------------------------- */
    for (let i = 0; i < uploaded.length; i++) {
      const { file, fileId } = uploaded[i];

      const genId = generateOrderId();

      saveMedia("image", "outgoing", genId, file);

      const now = new Date();
      const chatobj = {
        user_id: userinformation.id,
        agent_id: userinformation.agent_id,
        number: wadetails.wa_id,
        body: null,
        body_type: "image",
        file_title: "image",
        client_system_id: genId,
        file_id: fileId.split('.')[0],
        message_deliver: 0,
        type: "outgoing",
        date: now.toISOString().split("T")[0],
        time: now.toTimeString().split(" ")[0],
      };

      setCustomerschat(prev => ({
        ...prev,
        data: [chatobj, ...prev.data],
      }));


      const formData = new FormData();
      formData.append("user_id", userinformation.id);
      formData.append("agent_id", userinformation.agent_id);
      formData.append("number", wadetails.wa_id);
      formData.append("body_type", "image");
      formData.append("file_title", "image");
      formData.append("message_deliver", 0);
      formData.append("type", "outgoing");
      formData.append("client_system_id", genId);
      formData.append("file", fileId);

      await fetch(`${domain()}/sendmessage`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      /* push chat like OLD SendImage */


      setProgress(50 + Math.round(((i + 1) / uploaded.length) * 50)); // 100%
    }

    setUploading(false);
    onClose();
  };

  return (
    <div style={overlay}>
      <div style={modal}>

        {/* ✅ IMAGE GRID */}
        <div style={grid}>
          {files.map((file, i) => (
            <div key={i} style={imgWrapper}>
              <img
                src={URL.createObjectURL(file)}
                alt=""
                style={img}
              />

              {/* ❌ remove button */}
              {!uploading && (
                <button
                  style={removeBtn}
                  onClick={() => removeFile(i)}
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>

        {/* FOOTER */}
        <div style={footer}>
          {uploading ? (
            <div>Uploading... {progress}%</div>
          ) : (
            <button onClick={handleSend} style={btn}>
              Send {files.length} Image(s)
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export function VideoUploadModal({
  uploadData,
  setCustomerschat,
  onClose,
}) {

  const [progress, setProgress] = useState(0);
  const [status, setStatus] = useState("Initializing...");

  const { file, wadetails } = uploadData;

  const token = getToken();
  const userinfo = decodeJWT(token);

  useEffect(() => {

    const processUpload = async () => {

      try {

        const clientSystemId = generateOrderId();

        const chunkSize = 1024 * 1024 * 2;

        const totalChunks = Math.ceil(file.size / chunkSize);

        const fileName = `${clientSystemId}_${file.name}`;

        let finalFileId = null;

        // chunk upload
        for (let i = 0; i < totalChunks; i++) {

          const start = i * chunkSize;

          const end = Math.min(start + chunkSize, file.size);

          const blob = file.slice(start, end);

          const formData = new FormData();

          formData.append("user_id", userinfo.id);
          formData.append("agent_id", userinfo.agent_id);
          formData.append("number", wadetails.wa_id);
          formData.append("body_type", "video");

          formData.append("chunkIndex", i);
          formData.append("totalChunks", totalChunks);
          formData.append("fileName", fileName);

          formData.append("file", blob, file.name);

          setStatus(`Uploading chunk ${i + 1} of ${totalChunks}`);

          const res = await fetch(
            `${domain()}/sendmessage/uploade_file`,
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
              body: formData,
            }
          );

          if (!res.ok) {
            throw new Error("Chunk upload failed");
          }

          const data = await res.json();

          if (data.file_id) {
            finalFileId = data.file_id;
          }

          setProgress(
            Math.round(((i + 1) / totalChunks) * 90)
          );
        }

        if (!finalFileId) {
          throw new Error("No file id returned");
        }

        // save local cache
        saveMedia(
          "video",
          "outgoing",
          finalFileId.split(".").shift(),
          file
        );

        // send message
        const msgFormData = new FormData();

        msgFormData.append("user_id", userinfo.id);
        msgFormData.append("agent_id", userinfo.agent_id);
        msgFormData.append("number", wadetails.wa_id);

        msgFormData.append(
          "client_system_id",
          clientSystemId
        );

        msgFormData.append("body_type", "video");

        msgFormData.append("file_title", file.name);

        msgFormData.append("message_deliver", 0);

        msgFormData.append("type", "outgoing");

        msgFormData.append("file", finalFileId);

        const now = new Date();

        const chatObj = {
          user_id: userinfo.id,
          agent_id: userinfo.agent_id,
          number: wadetails.wa_id,
          body: null,
          body_type: "video",
          file_title: file.name,
          file_id: finalFileId.split(".").shift(),
          message_deliver: 0,
          type: "outgoing",
          client_system_id: clientSystemId,
          date: now.toISOString().split("T")[0],
          time: now.toTimeString().split(" ")[0],
        };

        setCustomerschat((prev) => ({
          ...prev,
          data: [chatObj, ...prev.data],
        }));

        await fetch(`${domain()}/sendmessage`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: msgFormData,
        });

        setProgress(100);

        setStatus("Success!");

        setTimeout(onClose, 1000);

      } catch (err) {

        console.error(err);

        alert(err.message);

        onClose();
      }
    };

    processUpload();

  }, []);

  return (
    <div style={docOverlayStyle}>
      <div style={docModalStyle}>

        <h5>Uploading Video</h5>

        <div
          style={{
            fontSize: "0.9rem",
            marginBottom: "10px",
          }}
        >
          {file.name}
        </div>

        <div style={progressContainerStyle}>
          <div
            style={{
              ...progressBarStyle,
              width: `${progress}%`,
            }}
          />
        </div>

        <div
          style={{
            marginTop: "10px",
            textAlign: "center",
          }}
        >
          {status} ({progress}%)
        </div>

      </div>
    </div>
  );
}

const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999,
};

const modal = {
  width: "90%",
  maxWidth: "600px",
  background: "#fff",
  borderRadius: "12px",
  display: "flex",
  flexDirection: "column",
  maxHeight: "80vh",
};

const grid = {
  overflowY: "auto",
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill,minmax(100px,1fr))",
  gap: "8px",
  padding: "10px",
  flex: 1,
};

const img = {
  width: "100%",
  height: "100px",
  objectFit: "cover",
  borderRadius: "8px",
};

const footer = {
  padding: "10px",
  borderTop: "1px solid #eee",
};

const btn = {
  width: "100%",
  padding: "10px",
  background: "#25D366",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
};

const imgWrapper = {
  position: "relative",
  border: "2px solid #000",   // ✅ black border
  borderRadius: "8px",
  overflow: "hidden",
};

const removeBtn = {
  position: "absolute",
  top: "4px",
  right: "4px",
  background: "red",
  color: "white",
  border: "none",
  borderRadius: "50%",
  width: "22px",
  height: "22px",
  cursor: "pointer",
  fontWeight: "bold",
  lineHeight: "18px",
};

